import { Component } from "react";
import { message, PageHeader, Spin, Upload, Row, Col, Alert, Switch } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { TableItem, ButtonItem } from "../../../../Components/Items";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx-js-style";
import { encodeId, decodeId } from "../../../../Components/idEncoder";

const GRUPOS_EXCEL = [
  { label: "ID", color: "595959", columnas: ["ID"] },
  { label: "Insumo del Sistema", color: "1890FF", columnas: ["Clave Interna", "Insumo"] },
  {
    label: "Datos para el Cliente",
    color: "52C41A",
    columnas: ["Nombre para el Cliente", "Clave Cliente", "Precio Unitario", "Unidad", "Presentación"],
  },
];
const COLOR_REFERENCIA = "595959";

const aclararColor = (hex, factor) => {
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const mezclar = (c) => Math.round(c + (255 - c) * factor);
  const aHex = (c) => c.toString(16).padStart(2, "0").toUpperCase();
  return `${aHex(mezclar(r))}${aHex(mezclar(g))}${aHex(mezclar(b))}`;
};
const BORDE_FINO = {
  top: { style: "thin", color: { rgb: "C0C0C0" } },
  bottom: { style: "thin", color: { rgb: "C0C0C0" } },
  left: { style: "thin", color: { rgb: "C0C0C0" } },
  right: { style: "thin", color: { rgb: "C0C0C0" } },
};
const estiloBannerGrupo = (color) => ({
  fill: { fgColor: { rgb: color } },
  font: { bold: true, color: { rgb: "FFFFFF" }, sz: 11, name: "Arial" },
  alignment: { horizontal: "center", vertical: "center" },
  border: BORDE_FINO,
});
const estiloEncabezadoColumna = (color) => ({
  fill: { fgColor: { rgb: aclararColor(color, 0.75) } },
  font: { bold: true, sz: 10, name: "Arial" },
  alignment: { horizontal: "center", vertical: "center", wrapText: true },
  border: BORDE_FINO,
});

class EdicionMasivaInsumosCliente extends Component {
  state = {
    loading: false,
    clienteId: this.props.location.state?.clienteId,
    clienteNombre: this.props.location.state?.clienteNombre || "",
    itemsMap: {},
    todasUnidades: [],
    archivosExcel: [],
    data: [],
    columnasPresentes: [],
    archivoError: null,
    errores: 0,
    soloConCambios: true,
    sinIdError: false,
    erroresBackend: [],
  };

  componentDidMount() {
    if (!this.state.clienteId) {
      message.error("No se encontró el cliente");
      this.atras();
      return;
    }
    this.setState({ loading: true });
    Promise.all([
      axios.post(
        "insumosCliente/selectInsumosPersonalizadosCliente",
        { empresaId: this.props.empresaId, clienteId: this.state.clienteId, page: 1, pageSize: 100000 },
        { headers: this.props.headersToken }
      ),
      axios.post(
        "unidades/selectUnidades",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
    ]).then(([resInsumos, resUnidades]) => {
      const itemsMap = {};
      if (resInsumos.data.success === 2) {
        (resInsumos.data.data || []).forEach((item) => {
          itemsMap[String(item._id)] = item;
        });
      }
      this.setState({
        itemsMap,
        todasUnidades: Array.isArray(resUnidades.data) ? resUnidades.data : [],
        loading: false,
      });
    });
  }

  atras() {
    this.props.history.goBack();
  }

  nombreUnidad(unidad) {
    if (!unidad?.unidadSat?.c_ClaveUnidad) return "";
    return `${unidad.unidadSat.c_ClaveUnidad} - ${unidad.nombre}`;
  }

  valorColumnaItem(item, col) {
    switch (col) {
      case "ID": return encodeId(String(item._id));
      case "Clave Interna": return item.claveInterna || "";
      case "Insumo": return item.descripcion || "";
      case "Nombre para el Cliente": return item.nombreAlternativo || "";
      case "Clave Cliente": return item.clave || "";
      case "Precio Unitario": return item.precio ?? "";
      case "Unidad": return item.unidadNombre || "";
      case "Presentación": return item.presentacion || "";
      default: return "";
    }
  }

  descargarExcel() {
    const { itemsMap, todasUnidades } = this.state;
    const items = Object.values(itemsMap);
    if (!items.length) {
      message.warning("Este cliente no tiene insumos cargados para descargar");
      return;
    }
    const wb = XLSX.utils.book_new();

    const columnas = GRUPOS_EXCEL.flatMap((g) => g.columnas);
    const filaGrupos = GRUPOS_EXCEL.flatMap((g) => g.columnas.map(() => g.label));
    const filasDatos = items.map((item) => columnas.map((col) => this.valorColumnaItem(item, col)));

    const ws = XLSX.utils.aoa_to_sheet([filaGrupos, columnas, ...filasDatos]);

    const merges = [];
    let indiceColumna = 0;
    GRUPOS_EXCEL.forEach((grupo) => {
      if (grupo.columnas.length > 1) {
        merges.push({ s: { r: 0, c: indiceColumna }, e: { r: 0, c: indiceColumna + grupo.columnas.length - 1 } });
      }
      grupo.columnas.forEach(() => {
        const cellGrupo = XLSX.utils.encode_cell({ r: 0, c: indiceColumna });
        const cellCol = XLSX.utils.encode_cell({ r: 1, c: indiceColumna });
        if (ws[cellGrupo]) ws[cellGrupo].s = estiloBannerGrupo(grupo.color);
        if (ws[cellCol]) ws[cellCol].s = estiloEncabezadoColumna(grupo.color);
        indiceColumna += 1;
      });
    });
    ws["!merges"] = merges;
    ws["!cols"] = columnas.map((h) => ({ wch: Math.max(h.length + 2, 15) }));
    ws["!rows"] = [{ hpt: 22 }, { hpt: 28 }];
    XLSX.utils.book_append_sheet(wb, ws, "Insumos");

    const unidadesFormateadas = todasUnidades.map((u) => this.nombreUnidad(u)).filter(Boolean);
    if (unidadesFormateadas.length) {
      const wsUnidades = XLSX.utils.aoa_to_sheet([["Unidad"], ...unidadesFormateadas.map((texto) => [texto])]);
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: 0 });
      if (wsUnidades[cellRef]) wsUnidades[cellRef].s = estiloBannerGrupo(COLOR_REFERENCIA);
      wsUnidades["!cols"] = [{ wch: 30 }];
      XLSX.utils.book_append_sheet(wb, wsUnidades, "Catalogo Unidad");
    }

    const instrucciones = [
      ["Instrucciones de uso"],
      [""],
      ["1. La columna ID es OBLIGATORIA y NO debe modificarse ni eliminarse."],
      ["2. Puede BORRAR las columnas que NO desee editar. Solo se modificarán las columnas presentes en el archivo."],
      ["3. Las columnas Clave Interna e Insumo son solo de referencia, no se toman en cuenta al guardar."],
      ["4. Nombre para el Cliente es obligatorio y no puede quedar vacío."],
      ["5. Unidad: escriba exactamente la clave y nombre tal como aparece en la hoja \"Catalogo Unidad\" (ej. H87 - Pieza). Deje la celda vacía para quitar la unidad."],
      ["6. Presentación: texto libre (ej. Caja 24 pz). Si se captura, se imprime en el PDF en vez de la Unidad. Deje la celda vacía para quitarla."],
      ["7. Las primeras dos filas son encabezados: la fila 1 agrupa las columnas por sección, la fila 2 trae el nombre real de cada columna. No borre ninguna de las dos."],
    ];
    const wsInstr = XLSX.utils.aoa_to_sheet(instrucciones);
    wsInstr["!cols"] = [{ wch: 95 }];
    XLSX.utils.book_append_sheet(wb, wsInstr, "Instrucciones");

    XLSX.writeFile(wb, "edicion_masiva_insumos_cliente.xlsx");
  }

  onChangeArchivo(e) {
    this.setState({ loading: true });
    if (
      e.file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      this.setState({
        archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading" }],
      });
      this.cargarArchivoExcel(e.file);
    } else {
      message.error("El archivo debe ser un archivo de Excel (.xlsx)");
      this.setState({ loading: false });
    }
  }

  cargarArchivoExcel(file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const primeraHoja = workbook.SheetNames[0];
      const filas = XLSX.utils.sheet_to_json(
        workbook.Sheets[primeraHoja],
        { defval: "", range: 1 }
      );
      this.procesarFilas(filas).then((result) => {
        this.setState({
          data: result.data,
          columnasPresentes: result.columnasPresentes,
          errores: result.errores,
          archivoError: result.errores > 0 ? result.archivoErrores : null,
          sinIdError: result.sinIdError,
          archivosExcel: [{ ...file, name: file.name, status: "success" }],
          loading: false,
          erroresBackend: [],
        });
        if (result.sinIdError) {
          message.error(
            "El archivo no contiene la columna ID. Descargue el Excel desde este módulo e intente nuevamente."
          );
        } else if (result.errores > 0) {
          message.warning(
            `Se detectaron ${result.errores} errores. Descargue el archivo de errores para revisarlos.`
          );
        } else {
          const conCambios = result.data.filter((d) => d._hayCambios).length;
          message.success(
            `Archivo leído: ${conCambios} insumo(s) con cambios de ${result.data.length} leídos.`
          );
        }
      });
    };
  }

  async procesarFilas(filas) {
    if (!filas.length)
      return {
        data: [],
        columnasPresentes: [],
        errores: 0,
        sinIdError: false,
        archivoErrores: null,
      };

    const { itemsMap, todasUnidades } = this.state;

    const primeraFila = filas[0];
    if (!("ID" in primeraFila)) {
      return {
        data: [],
        columnasPresentes: [],
        errores: 0,
        sinIdError: true,
        archivoErrores: null,
      };
    }

    const TODAS_EDITABLES = ["Nombre para el Cliente", "Clave Cliente", "Precio Unitario", "Unidad", "Presentación"];
    const columnasPresentes = TODAS_EDITABLES.filter((col) => col in primeraFila);

    const PATRON_STRING = /^[A-Za-z0-9\n.: ,"'´`¨=ø$#°ºªáÁéÉíÍóÓúÚüÜñÑ@_/*+%&()!-_{¼³ ]*$/;

    const erroresRows = [];
    const data = [];
    let errores = 0;

    for (const fila of filas) {
      const encodedId = String(fila["ID"] || "").trim();
      const decodedId = encodedId ? decodeId(encodedId) : null;
      const item = decodedId ? itemsMap[decodedId] : null;
      if (!encodedId || !item) {
        errores++;
        erroresRows.push({
          ...fila,
          Errores: !encodedId ? "ID vacío" : `ID no encontrado: ${encodedId}`,
        });
        continue;
      }

      const obj = {
        itemId: String(item._id),
        claveInterna: item.claveInterna,
        descripcion: item.descripcion,
      };
      const cambios = [];
      const filaErrores = [];

      for (const col of columnasPresentes) {
        const val = String(fila[col] ?? "").trim();

        if (col === "Nombre para el Cliente") {
          if (!val) {
            filaErrores.push(`${col}: no puede estar vacío`);
            continue;
          }
          if (!PATRON_STRING.test(val)) {
            filaErrores.push(`${col}: contiene caracteres no aceptados`);
            continue;
          }
          obj.nombreAlternativo = val;
          obj["_d_Nombre para el Cliente"] = val;
          if (String(item.nombreAlternativo || "") !== val) cambios.push(col);
        } else if (col === "Clave Cliente") {
          if (val && !PATRON_STRING.test(val)) {
            filaErrores.push(`${col}: contiene caracteres no aceptados`);
            continue;
          }
          obj.clave = val;
          obj["_d_Clave Cliente"] = val;
          if (String(item.clave || "") !== val) cambios.push(col);
        } else if (col === "Precio Unitario") {
          if (val === "") {
            obj.precio = null;
            obj["_d_Precio Unitario"] = "";
            if (item.precio !== undefined && item.precio !== null) cambios.push(col);
          } else {
            const num = Number(String(val).replace(/\$\s?|(,*)/g, ""));
            if (isNaN(num)) {
              filaErrores.push(`${col}: "${val}" no es un número`);
              continue;
            }
            obj.precio = num;
            obj["_d_Precio Unitario"] = `$${num}`;
            if (String(item.precio ?? "") !== String(num)) cambios.push(col);
          }
        } else if (col === "Presentación") {
          if (val && !PATRON_STRING.test(val)) {
            filaErrores.push(`${col}: contiene caracteres no aceptados`);
            continue;
          }
          obj.presentacion = val;
          obj["_d_Presentación"] = val;
          if (String(item.presentacion || "") !== val) cambios.push(col);
        } else if (col === "Unidad") {
          if (val === "") {
            obj.unidadId = null;
            obj._d_Unidad = "";
            if (item.unidadId) cambios.push(col);
          } else {
            const unidad = todasUnidades.find((u) => this.nombreUnidad(u) === val);
            if (!unidad) {
              filaErrores.push(`Unidad: "${val}" no es una unidad válida`);
              continue;
            }
            obj.unidadId = unidad._id;
            obj._d_Unidad = val;
            const idActual = String(item.unidadId || "");
            if (idActual !== String(unidad._id)) cambios.push(col);
          }
        }
      }

      if (filaErrores.length) {
        errores++;
        erroresRows.push({ ...fila, Errores: filaErrores.join("; ") });
      } else {
        obj._cambios = cambios;
        obj._hayCambios = cambios.length > 0;
        data.push(obj);
      }
    }

    const archivoEditar = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      archivoEditar,
      XLSX.utils.json_to_sheet(erroresRows),
      "Errores"
    );
    return {
      data,
      columnasPresentes,
      errores,
      sinIdError: false,
      archivoErrores: archivoEditar,
    };
  }

  descargarArchivoErrores() {
    if (!this.state.archivoError) return;
    const wbout = XLSX.write(this.state.archivoError, {
      bookType: "xlsx",
      type: "binary",
    });
    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "errores_edicion_masiva_insumos_cliente.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onFinish() {
    const dataConCambios = this.state.data.filter((d) => d._hayCambios);
    if (!dataConCambios.length) {
      message.warning("No hay cambios que guardar");
      return;
    }
    const dataParaEnviar = dataConCambios.map((row) => {
      const obj = {};
      for (const key in row) {
        if (
          !key.startsWith("_d_") &&
          key !== "_cambios" &&
          key !== "_hayCambios" &&
          key !== "claveInterna" &&
          key !== "descripcion"
        ) {
          obj[key] = row[key];
        }
      }
      return obj;
    });

    this.setState({ loading: true, erroresBackend: [] });
    axios
      .post(
        "insumosCliente/editarInsumosPersonalizadosClienteMasivo",
        {
          empresaId: this.props.empresaId,
          clienteId: this.state.clienteId,
          data: dataParaEnviar,
          columnas: this.state.columnasPresentes,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const erroresBackend = res.data.errores || [];
          if (erroresBackend.length) {
            message.warning(
              `Se actualizaron ${res.data.numero} insumo(s). Se omitieron ${erroresBackend.length} por errores.`
            );
            this.setState({ erroresBackend });
          } else {
            message.success(`Se actualizaron ${res.data.numero} insumo(s)`);
            this.atras();
          }
        } else {
          message.error(res.data.message || "Hubo un error al actualizar los insumos del cliente");
        }
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const {
      data,
      columnasPresentes,
      errores,
      sinIdError,
      soloConCambios,
      erroresBackend,
      clienteNombre,
    } = this.state;

    const totalConCambios = data.filter((d) => d._hayCambios).length;
    const dataMostrar = soloConCambios
      ? data.filter((d) => d._hayCambios)
      : data;

    const columnasReferencia = [
      {
        title: "Clave Interna",
        dataIndex: "claveInterna",
        key: "claveInterna",
        fixed: "left",
        width: 100,
      },
      {
        title: "Insumo",
        dataIndex: "descripcion",
        key: "descripcion",
        fixed: "left",
        width: 200,
      },
    ];

    const renderCelda = (col) => (_, record) => {
      const val = record[`_d_${col}`] ?? String(record[col] ?? "");
      const changed = record._cambios && record._cambios.includes(col);
      return (
        <span
          style={{
            backgroundColor: changed ? "#fff3cd" : undefined,
            padding: changed ? "2px 6px" : undefined,
            borderRadius: changed ? 4 : undefined,
            display: "inline-block",
          }}
        >
          {val}
        </span>
      );
    };

    const columnasEditables = columnasPresentes.map((col) => ({
      title: col,
      key: col,
      width: 180,
      render: renderCelda(col),
    }));

    const columns = [...columnasReferencia, ...columnasEditables];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={`Edición Masiva de Insumos${clienteNombre ? ` - ${clienteNombre}` : ""}`}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.state.archivoError ? (
              <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>
                Descargar Errores
              </ButtonItem>
            ) : null
          }
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando, espere por favor...">
            <Alert
              style={{ marginBottom: 16, marginTop: 10 }}
              type="info"
              showIcon
              message="Instrucciones"
              description={
                <ol style={{ margin: 0, paddingLeft: 20 }}>
                  <li>Descargue el Excel con los insumos actualmente cargados para este cliente.</li>
                  <li>
                    <b>Borre las columnas que NO desee modificar.</b> Solo se
                    actualizarán las columnas que queden en el archivo.
                  </li>
                  <li>
                    La columna <b>ID</b> es obligatoria y no debe eliminarse ni
                    modificarse.
                  </li>
                  <li>
                    Suba el archivo modificado y revise la vista previa antes de
                    guardar.
                  </li>
                </ol>
              }
            />
            <Row style={{ marginBottom: 16, alignItems: "center" }}>
              <Col span={12}>
                <ButtonItem
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={this.descargarExcel.bind(this)}
                >
                  Descargar Excel
                </ButtonItem>
              </Col>
              <Col span={12}>
                <Upload
                  showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                  fileList={this.state.archivosExcel}
                  customRequest={this.onChangeArchivo.bind(this)}
                  accept=".xlsx"
                >
                  <ButtonItem icon={<UploadOutlined />}>
                    Subir Excel modificado
                  </ButtonItem>
                </Upload>
              </Col>
            </Row>

            {sinIdError && (
              <Alert
                type="error"
                showIcon
                message="El archivo no contiene la columna ID. Descargue el Excel desde este módulo y vuelva a intentarlo."
                style={{ marginBottom: 16 }}
              />
            )}

            {data.length > 0 && !sinIdError && (
              <>
                <Alert
                  type={errores > 0 ? "warning" : "success"}
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={
                    <>
                      Se detectaron <b>{totalConCambios}</b> insumo(s) con
                      cambios en las columnas:{" "}
                      <b>{columnasPresentes.join(", ")}</b>.
                      {errores > 0 && (
                        <>
                          {" "}Se omitieron <b>{errores}</b> fila(s) con
                          errores.
                        </>
                      )}
                    </>
                  }
                />
                {erroresBackend && erroresBackend.length > 0 && (
                  <Alert
                    type="error"
                    showIcon
                    style={{ marginBottom: 12 }}
                    message={`El backend rechazó ${erroresBackend.length} insumo(s):`}
                    description={
                      <ul style={{ margin: 0, paddingLeft: 20 }}>
                        {erroresBackend.map((e, idx) => {
                          const item = this.state.itemsMap[String(e.itemId)];
                          const nombre = item?.descripcion || e.itemId;
                          return (
                            <li key={idx}>
                              <b>{nombre}</b>: {e.motivo}
                            </li>
                          );
                        })}
                      </ul>
                    }
                  />
                )}
                <div
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    <Switch
                      checked={soloConCambios}
                      onChange={(v) => this.setState({ soloConCambios: v })}
                      size="small"
                    />{" "}
                    Mostrar solo con cambios ({totalConCambios} de {data.length})
                  </span>
                  {totalConCambios > 0 && (
                    <ButtonItem
                      type="primary"
                      onClick={this.onFinish.bind(this)}
                    >
                      Guardar cambios en {totalConCambios} insumo
                      {totalConCambios !== 1 ? "s" : ""}
                    </ButtonItem>
                  )}
                </div>
                <TableItem
                  size="small"
                  dataSource={dataMostrar}
                  columns={columns}
                  scroll={{ x: "max-content" }}
                  rowKey="itemId"
                />
              </>
            )}
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EdicionMasivaInsumosCliente);
